import format from 'date-fns/format'
import { Stats } from '../types'

export const getStatsYear = (date: string) => {
  if (!date) return ''

  return format(new Date(date), 'yyyy')
}

export const getStreakDate = (streakDate: string) => {
  return streakDate.split('T')[0]
}

export const getStreakDay = (streakDate: string) => {
  return parseInt(getStreakDate(streakDate).split('-')[2], 10)
}

export const getYearStatus = (stats: Stats): 'current' | 'past' | 'future' => {
  const currentYear = new Date().getFullYear()
  if (stats.year === currentYear) return 'current'
  if (stats.year < currentYear) return 'past'
  return 'future'
}
